function f(...n) {
  if (n.length === 0)
    throw new Error("No colors provided");
  if (n.length === 1)
    return n[0];
  function u(a) {
    const o = a.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!o)
      throw new Error("Invalid color format");
    const [, g, i, e, t] = o;
    return [parseInt(g), parseInt(i), parseInt(e), t ? parseFloat(t) : 1];
  }
  let [d, s, h, r] = u(n[0]);
  for (let a = 1; a < n.length; a++) {
    const [o, g, i, e] = u(n[a]), t = r + e * (1 - r);
    d = Math.round((d * r + o * e * (1 - r)) / t), s = Math.round((s * r + g * e * (1 - r)) / t), h = Math.round((h * r + i * e * (1 - r)) / t), r = t;
  }
  return `rgba(${d}, ${s}, ${h}, ${r})`;
}
export {
  f as blendCssColors
};
